export const error_500_toast_message = "مشکلی در سرور به وجود آمده؛ لطفاً دوباره تلاش کنید یا با پشتیبانی تماس بگیرید.";
export const session_ended_toast_message = "به دلیل اتمام زمان دسترسی شما، باید دوباره وارد سامانه شوید. درحال انتقال به صفحه ورود...";
